const ACCENT_MAP = {
  emerald: { bar: "bg-gradient-to-b from-emerald-500 to-emerald-700", label: "text-emerald-700/80" },
  indigo:  { bar: "bg-gradient-to-b from-indigo-500 to-indigo-700",  label: "text-indigo-700/80" },
  amber:   { bar: "bg-gradient-to-b from-amber-500 to-amber-700",    label: "text-amber-700/80" },
  rose:    { bar: "bg-gradient-to-b from-rose-500 to-rose-700",      label: "text-rose-700/80" },
  violet:  { bar: "bg-gradient-to-b from-violet-500 to-violet-700",  label: "text-violet-700/80" },
  teal:    { bar: "bg-gradient-to-b from-teal-500 to-teal-700",      label: "text-teal-700/80" },
  blue:    { bar: "bg-gradient-to-b from-blue-500 to-blue-700",      label: "text-blue-700/80" },
};

export default function PageHeader({ title, subtitle, actions, testid, accent = "emerald" }) {
  const tone = ACCENT_MAP[accent] || ACCENT_MAP.emerald;
  return (
    <div className="flex flex-col gap-4 mb-6 md:mb-8 md:flex-row md:items-start md:justify-between" data-testid={testid}>
      <div className="min-w-0">
        <div className="flex items-center gap-3 mb-2">
          <div className={`w-1.5 h-5 rounded-full ${tone.bar}`} />
          <div className={`text-xs uppercase tracking-[0.2em] font-bold ${tone.label}`}>rimmoGET</div>
        </div>
        <h1 className="font-heading text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-slate-500 mt-2 text-sm leading-relaxed max-w-2xl">{subtitle}</p>}
      </div>
      {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
    </div>
  );
}
